module.exports = __webpack_public_path__ + "images/host-icon.7e7b43cb.svg";